import { Injectable } from '@angular/core';
import { from, mergeMap } from 'rxjs';
import { getDefaultModalSettings } from 'src/app/common/utils/helpers';
import { OpenDialogService } from '../open-dialog/open-dialog.service';

@Injectable({ providedIn: 'root' })
export class CookieService {
  showCookieButton = true;
  constructor(private openDialogService: OpenDialogService) {}

  onManageCookies() {
    return from(import('src/app/_shared/dialogs/cookie-dialog/cookie-dialog.component')).pipe(
      mergeMap(({ CookieDialogComponent }) =>
        this.openDialogService
          .openDialog(CookieDialogComponent, {
            ...getDefaultModalSettings(),
          })
          .afterClosed(),
      ),
    );
  }
}
